import * as React from 'react'
import {Box,Typography,Container} from '@mui/material'
import {useTheme,styled } from '@mui/material/styles'
import {IconButton} from "@mui/material"
import Divider from '@mui/material/Divider';
import {useNavigate} from 'react-router-dom'
import Header from '../Components/Header'
import {useSelector, useDispatch} from 'react-redux';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import ItemView from '../Components/ItemView';
import { ArrowBack, CalendarMonth, CopyAll, EditNote, Groups, Remove, Timelapse } from '@mui/icons-material';
import delete_tst from '../Redux/reducers/delete_tst';

const TestDetail = ()=>{

	const theme = useTheme()
	const navigate = useNavigate()
	const [open, setOpen] = React.useState(false);
	const [showModal, setShowModal] = React.useState(false);
	const [message, setMessage] = React.useState("");
	const user = useSelector(state => state?.auth.user);
	const test = useSelector(state => state?.setting.activity);
	const tests = useSelector(state => state?.tests.tests);
	const dispatch = useDispatch()


const DescriptionText = ({text,limit})=>{
	const displayText = text?.length > limit ? text?.substring(0,limit) + '...' : text;
	return <Typography color="white" ml={1} fontSize={13}> {displayText} </Typography>
  }

	return(
		<Box width="100%">
			<Header title="Create Assessment">
				<Breadcrumbs aria-label="breadcrumb">
					<Link  sx={{fontSize:12,color:"gray"}} underline="hover" color="inherit" href="/dashboard">
						Dashboard
					</Link>
					<Typography sx={{fontSize:12,color:"gray"}}>Test Detail </Typography>
			</Breadcrumbs>			
			</Header>
			<Container>
				<Box m={2} sx={{backgroundColor:"black",borderRadius:5,padding:5,width:{xs:450,md:"100%",paddingLeft:1}}}>
					<Box m={1} display="flex" width="90%" flexDirection="row" justifyContent="space-between" alignItems="center">
						<Typography mt={5} mb={5} ml={5} style={{fontSize:16,fontWeight:400,fontFamily:"dinofans"}}>
							Assessment Detail
						</Typography>
						<IconButton  onClick={(e)=>{
                            e?.preventDefault()
                            navigate("/dashboard")
                        }}>
							<ArrowBack fontSize="small"/>
						</IconButton>
					</Box>
						<Box display="flex" flexWrap="wrap" justifyContent="space-between" pt={1}>
							<Box sx={{margin:1,padding:2,color:"gray",width:{md:"35%"}}}>
								<Typography sx={{fontFamily:"dinofans",marginBottom:1}}>
									Title
								</Typography>
								<DescriptionText limit={100} text={test?.from} />
							</Box>
							<Box sx={{margin:1,padding:2,color:"gray",width:{md:"55%"}}}>
								<Typography sx={{fontFamily:"dinofans",marginBottom:1}}>
									Description
								</Typography>
								<DescriptionText limit={100} text={test?.description} />
							</Box>
							<ItemView title="Questions" content={test?.questions}/>
							<ItemView title="Specialties" content={test?.specialty}/>
							<ItemView title="Fields" content={test?.field}/>
							<ItemView title="Level" content={test?.level}/>
							<ItemView title="Language" content={test?.language}/>
							<Box sx={{display:"flex",flexDirection:"row",justifyContent:"space-evenly",width:"100%",alignContent:"center",marginBottom:3}}>
								<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
									<IconButton>
										<CalendarMonth style={{color:"gray"}}/>
									</IconButton>
									<Typography color="white" fontSize={14} width={80}>
										{test?.start_date}
									</Typography>
								</Box>
								<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
									<IconButton>
										<CalendarMonth style={{color:"gray"}}/>
									</IconButton>
									<Typography color="white" fontSize={14} width={40}>
										{test?.start_moment}
									</Typography>
								</Box>
								<Box sx={{display:"flex",flexDirection:"row",justifyContent:"center",alignItems:"center"}}>
									<IconButton>
										<Timelapse style={{color:"gray"}}/>
									</IconButton>
									<Typography color="white" fontSize={14} width={60}>
										{test?.time} min
									</Typography>
								</Box>
							</Box>
						</Box>
				</Box>
			</Container>
		</Box>
		)
}

export default TestDetail